const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Fetch items from a collection with optional query parameters.
 * Uses the v2 paginated endpoint for consistency.
 */
export async function fetchCollection(collectionName, params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${BASE_URL}/v2/content/${collectionName}${query ? `?${query}` : ''}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch collection ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.error(`CMS fetch error for ${collectionName}:`, err);
    return { items: [], total: 0 };
  }
}

/**
 * Fetch a single page by its url_slug.
 */
export async function fetchPageBySlug(slug) {
  const data = await fetchCollection('sider', { url_slug: slug });
  return data.items?.[0] || null;
}

/**
 * Fetch a single service by its url_slug.
 */
export async function fetchServiceBySlug(slug) {
  const data = await fetchCollection('ydelser', { url_slug: slug });
  return data.items?.[0] || null;
}

/**
 * Fetch a single gallery by its url_slug.
 */
export async function fetchGalleryBySlug(slug) {
  const data = await fetchCollection('gallerier', { url_slug: slug });
  return data.items?.[0] || null;
}

/**
 * Fetch all reviews.
 */
export async function fetchReviews() {
  const data = await fetchCollection('anmeldelser');
  return data.items || [];
}

/**
 * Fetch all services (only Birgitte's 4 core focus areas).
 */
export async function fetchServices() {
  const data = await fetchCollection('ydelser');
  const items = data.items || [];
  const allowedSlugs = [
    'integrativ-psykoterapeut',
    'familiebehandler',
    'samvaerskonsulent',
    'supervisor'
  ];
  const filtered = items.filter(item => allowedSlugs.includes(item.url_slug));
  // If CMS doesn't match slugs directly, sort and retain matching or fallback
  return filtered.length > 0 ? filtered : items;
}
